// blog swiper
window.addEventListener("DOMContentLoaded", () => {
const swiper = new Swiper(".swiper", {
  slidesPerView: '1',
  spaceBetween: 16,
  grabCursor: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
      1070: {
      slidesPerView: '2'
    },
    570: {
      slidesPerView: '1'
    }
  },
});
});



